/**
 * Follow-Up to Queue Model Converter
 *
 * Converts CallFollowUpModel to QueueModel for use with PhoneCallSummaryModal.
 */

import type { CallFollowUpModel } from '@/modules/call-follow-up';
import type { QueueModel } from '../../domain/types';

/**
 * Convert a CallFollowUpModel to a QueueModel
 *
 * The PhoneCallSummaryModal expects a QueueModel, but we have CallFollowUpModel data.
 * This function maps the fields appropriately.
 */
export function convertFollowUpToQueueModel(followUp: CallFollowUpModel): QueueModel {
  // Same party the follow-up card shows: the callee (customer), falling back to the caller
  const party = followUp.callee ?? followUp.caller;

  return {
    id: followUp.id,
    loan_id: followUp.loan_id,
    case_id: followUp.case_id,
    name: party?.name ?? 'Unknown',
    role: party?.role ?? '',
    relationship: '',
    tags: [],
    time_start: followUp.time_start,
    time_end: followUp.time_end,
    status: 'followUp',
    order: 0,
    tier: followUp.assigned_tier ?? '',
    callee: party?.mobile_number ?? '',
    caller: {
      id: followUp.caller?.id,
      full_name: followUp.caller?.name,
      photo_url: followUp.caller?.photo_url,
      mobile_number: followUp.caller?.mobile_number,
    },
    callee_details: {
      name: party?.name,
      nric: party?.nric,
      role: party?.role,
    },
    has_transcript: true, // Follow-ups typically have transcripts
    is_fallback: false,
    has_call_detail: true,
    queue_call_id: followUp.queue_call_id,
    incoming_call_id: followUp.incoming_call_id,
  };
}
